module.exports = __webpack_public_path__ + "static/media/promocode-bonus-header-image.c4b141bf.png";